import { Box } from '@chakra-ui/react';
import moment from 'moment';

import { TableColumn, booleanBodyRender } from '@app/components/common/table';
import { Txt } from '@app/components/common'; 
import { Session } from '@app/api/socket-service';


// eslint-disable-next-line import/no-anonymous-default-export
export const useColumns = (): TableColumn<Session>[] => {
  return [
    {
      name: 'username',
      label: 'Пользователь',
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: 'userInfo',
      label: 'Пользователь',
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: 'created',
      label: 'Создано',
      options: {
        filter: {
          name: 'created',
          type: 'date-range',
          onApply: (value) => value + 'T00:00:00',
        },
        sort: true,
        customBodyRender: (timestamp: number) => <Txt color="gray.500">{moment(timestamp).format('DD.MM.YYYY HH:mm')}</Txt>,
      },
    },
    {
      name: 'lastVisit',
      label: 'Последний визит',
      options: {
        filter: {
          name: 'createdTimestamp',
          type: 'date-range',
          onApply: (value) => value + 'T00:00:00',
        },
        sort: true,
        customBodyRender: (timestamp: number) => <Txt color="gray.500">{moment(timestamp).format('DD.MM.YYYY HH:mm')}</Txt>,
      },
    },
    {
      name: 'closed',
      label: 'Online',
      options: {
        filter: false,
        sort: true,
        customBodyRender: (value) => {
          return booleanBodyRender()(!value);
        }
      },
    },
    {
      name: 'deviceId',
      label: 'Устройство ID',
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: 'device',
      label: 'Смартфон/Операционная система',
      options: {
        filter: false,
        sort: true,
        customBodyRender: (value: string) => {
          const parsed = JSON.parse(value);
          return <Box whiteSpace='pre-wrap'>
            <Txt color="brand.500">{parsed.brand}</Txt>
            <Txt color="gray.500">{parsed.osName} (ver. {parsed.osVersion})</Txt>
          </Box>;
        },
      },
    },
    {
      name: 'appVersion',
      label: 'Версия приложения',
      options: {
        filter: false,
        sort: false,
      },
    },
  ];
};
